import { render, staticRenderFns } from "./PrescriptionRecord.vue?vue&type=template&id=09a8c5f5&scoped=true"
import script from "./PrescriptionRecord.vue?vue&type=script&lang=js"
export * from "./PrescriptionRecord.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionRecord.vue?vue&type=style&index=0&id=09a8c5f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a8c5f5",
  null
  
)

export default component.exports